import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';

import SearchBarNE from '../../../../../shared/components/SearchBarNE/SearchBarNE';
import BdsButton from '../../../../../shared/components/v3/Buttons/BdsButton/BdsButton';
import GenericMenu from '../../../../../shared/components/v3/GenericMenu/GenericMenu';
import { FILTER_IMAGES } from '../../../../../shared/constants/images';
import { STORIES_TYPE_ALL_VALUE, STORIES_TYPE_MENU } from '../../../../../shared/constants/stories';
import { CLICK_ACTION, STORY_SECTION } from '../../../../../shared/constants/tagManager';
import { IUserCompany } from '../../../../../shared/interfaces/businessData';
import { IStoriesFilters } from '../../../../../shared/interfaces/stories';
import TagManagerService from '../../../../../shared/services/gtm/tagManagerService';
import { TRANSLATION_STORIES_LIST } from '../../../../../shared/translations/stories';

import './StoriesTableFilter.scss';

interface StoriesTableFilterProps {
  company: IUserCompany;
  loading: boolean;
  storiesFilters: IStoriesFilters;
  changeStoriesFilters: (storiesFilters: IStoriesFilters) => void;
}

const StoriesTableFilter = ({ loading, company, storiesFilters, changeStoriesFilters }: StoriesTableFilterProps) => {
  const [showGenericMenu, setShowGenericMenu] = useState<boolean>(false);
  const { t } = useTranslation();

  const typeOptions = STORIES_TYPE_MENU.map((option) => ({
    name: t(option.label),
    value: option.value ?? STORIES_TYPE_ALL_VALUE
  }));

  const handleSearch = (search: string) => {
    changeStoriesFilters({ ...storiesFilters, searchValue: search });
  };

  const handleGenericMenu = () => {
    setShowGenericMenu(!showGenericMenu);
  };

  const changeType = (value: string) => {
    const typeOption = STORIES_TYPE_MENU.find((option) => (option.value ?? STORIES_TYPE_ALL_VALUE) === value);
    if (!typeOption) return;

    setShowGenericMenu(false);
    changeStoriesFilters({ ...storiesFilters, type: typeOption });
    TagManagerService.pushEvent(CLICK_ACTION, STORY_SECTION, typeOption.gtmTag);
  };

  return (
    <div className="stories-filter-container">
      <div className="filter-row column-mobile">
        <div className="filter-bar-container">
          <SearchBarNE
            placeholder={t(TRANSLATION_STORIES_LIST.search.detail)}
            onSearch={handleSearch}
            placeholderSmall={t(TRANSLATION_STORIES_LIST.search.mobile)}
            company={company}
            loading={loading}
          />
        </div>
        <div className="filter-button-container">
          <BdsButton
            action={handleGenericMenu}
            variant="secondary"
            size="m"
            iconLeft={FILTER_IMAGES}
            disabled={loading}
          >
            {t(TRANSLATION_STORIES_LIST.filterButton)}
          </BdsButton>
          <GenericMenu
            setShowGenericMenu={setShowGenericMenu}
            showGenericMenu={showGenericMenu}
            title={t(TRANSLATION_STORIES_LIST.filterButton)}
            company={company}
            type="custom"
            className="stories-generic-menu"
            customData={{
              showButtonFilter: true,
              defaultValueOnFilterButton: true,
              typeCheckbox: 'square',
              data: typeOptions,
              onChanged: changeType,
              value: STORIES_TYPE_ALL_VALUE
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default StoriesTableFilter;
